/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains all the administration asynchronous routes used in the application.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/*
 * Used to allow for the use of function component.
 */
import { lazy } from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/*
 * Used to load components asychronously.
 */
import { IRoute } from '..';

/*
 * Used to get access to the API types and requests
 */
import * as FaceMatchDtos from '../../dtos/FaceMatch.dtos';

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

/**
 * Asynchronous administration page wrapping component
 */
export const AsyncAdministrationWrapperComponent = lazy(() => import('../../pages/administration/AdministrationWrapperPage/ConnectedAdministrationWrapperPage'));

/**
 * Asynchronous administration dashboard page component
 */
export const AsyncDashboardPage = lazy(() => import('../../pages/administration/DashboardPage/DashboardPage'));

/**
 * Asynchronous administration people page component
 */
export const AsyncPeoplePage = lazy(() => import('../../pages/administration/PeoplePage/ConnectedPeoplePage'));

/**
 * Asynchronous administration invitations page component
 */
export const AsyncInvitationsPage = lazy(() => import('../../pages/administration/InvitationsPage/ConnectionInvitationsPage'));

/**
 * Asynchronous administration profile page component
 */
export const AsyncProfilePage = lazy(() => import('../../pages/administration/ProfilePage/ConnectedProfilePage'));
export const AsyncOmimUploadPage = lazy(() => import('../../pages/administration/OmimUpload/ConnectedOmimUploadPage'));

/**
 * Asynchronous administration email page component
 */
export const AsyncEmailLogPage = lazy(() => import('../../pages/administration/EmailLogPage/ConnectedEmailLogPage'));
export const AsyncMmeRemoteSiteStatisticsPage = lazy(() => import('../../pages/administration/MmeRemoteSiteStatisticsPage/MmeRemoteSiteStatisticsPage'));
const administrationRoute: IRoute = {
  component: AsyncAdministrationWrapperComponent,
  path: '/administration',
  requiresAuthentication: true,
  requiredRoles: [FaceMatchDtos.Role.Administrator, FaceMatchDtos.Role.SuperUser],
  childRoutes: {
    mmeRemoteSiteStatistics: {
      component: AsyncMmeRemoteSiteStatisticsPage,
      path: '/administration/mme/remote-sites'
    },
    people: {
      component: AsyncPeoplePage,
      path: '/administration/people'
    },
    person: {
      component: AsyncProfilePage,
      path: '/administration/profile/:id'
    },
    invitations: {
      component: AsyncInvitationsPage,
      path: '/administration/invitations'
    },
    profile: {
      component: AsyncProfilePage,
      path: '/administration/profile'
    },
    omimUpload: {
      component: AsyncOmimUploadPage,
      path: '/administration/omimupload'
    },
    emaillog: {
      component: AsyncEmailLogPage,
      path: '/administration/emaillog'
    },
    dashboard: {
      component: AsyncDashboardPage,
      path: '/administration'
    }
  }
};
export default administrationRoute;